module.exports = __webpack_public_path__ + "img/jordan.cc35716.webp";